import Dialog from 'components/Dialog';
import React from 'react';
import {useDispatch} from 'react-redux';
import {usePostApi} from 'common/hooks/usePostApi';
import api from 'api';
import history from 'redux/history';
import {packId} from 'common/diplomatIdUtil';
import actions from 'features/layout/redux/actions';
import FormikTextField from 'components/inputs/FormikTextField';
import {useTranslation} from 'react-i18next';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {DialogTypes} from 'common/names';
import Formik from 'components/hook-form/Formik';
import {IVFSNode, IVFSNodeDiplomat, VFSNode, VFSNodeDiplomat} from 'types/diplomat/sftp/VFSNode';
import {FormLabel, Grid} from '@mui/material';
import {GridCentered} from 'components/GridCentered';
import FormikBrowseFileInput from 'components/inputs/FormikBrowseFileInput';
import {enums} from 'types/enums';
import {truncatePath} from 'common/stringUtils';
import {VFS_PATH} from 'common/constants';

type Props = {
   open?: boolean;
   data?: IVFSNodeDiplomat;
   onClose: () => void;
};

const CreateVirtualFolderDialog = ({open = true, data, onClose}: Props) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();
   const {request} = usePostApi<IVFSNodeDiplomat>(api.vfs, {onFailure: onClose});
   const handleSubmit = (values: IVFSNode) => {
      const vfspath = `${path}/${values.vfspath}`;
      request(
         JSON.stringify({
            ...values,
            parentId: data?.id,
            nodeType: enums.vfsType.enum.VIRTUAL,
            nodeName: values.vfspath,
            vfspath,
            // path: ((data as unknown) as IVFSNode).absolutePath + values.name,
            // // overwrite: true,
            // folderId: data?.id || null,
            // objectType: DiplomatObjectType.enum.SFTP_GROUP,
            // suspended: false,
         }),
         {
            onSuccess: (_data: IVFSNode) => {
               dispatch(actions.loadTreeNav());
               onClose();
               history.push(`${VFS_PATH}${vfspath}`);
            },
         }
      );
   };
   const path = data?.absolutePath || data?.path || '';
   return (
      <Dialog
         maxWidth="sm"
         header={DialogTypes.CreateVirtualFolderDialog.dialogName}
         open={open}
         close={onClose}
      >
         <Formik
            initialValues={VFSNode.cast({
               vfspath: '',
            })}
            onSubmit={handleSubmit}
         >
            <>
               <Grid container spacing={1}>
                  {/* <GridCentered item>
                     <FormLabel title={path}>{truncatePath(path)}/</FormLabel>
                  </GridCentered> */}

                  <GridCentered item>
                     <FormLabel title={path}>{truncatePath(path)}/</FormLabel>
                  </GridCentered>
                  <GridCentered item flexGrow={1}>
                     <FormikTextField
                        autoFocus
                        required
                        label={t('New Filesystem node:')}
                        name={'vfspath'}
                     />
                  </GridCentered>
                  <Grid item xs={12}>
                     <FormikBrowseFileInput
                        autoFocus
                        // required
                        label={t('Path:')}
                        name={'path'}
                        // directoriesOnly
                        // sanitizer={(val) => escapeFile(val)}
                     />
                  </Grid>
               </Grid>
               <FormFooterButtons cancel={onClose} />
            </>
         </Formik>
      </Dialog>
   );
};

export default CreateVirtualFolderDialog;
